@if (field.label.length) {
  <div class="label" [title]="title">{{ field.label }}</div>
}
<div class="value" [title]="title" [style]="fieldStyle">
  @for (item of contentItems; track item.index) {
    @if (item.link) {
      @if (item.isVirtualFile) {
        <pub-attachment-render-wrapper [fileId]="item.fileId!"/>
      }
      @if (!item.isVirtualFile) {
        <pub-link-render [refLink]="item.link" [text]="item.content"
        (conceptSelected)="selectConcept($event)"></pub-link-render>
      }
    }
    @if (!item.link) {
      <span [innerHTML]="item.content | highlight:highlightTerm | lineBreak"></span>
    }
  }
</div>
